import type { NDateLocale } from './enUS'
import { az } from 'date-fns/locale'

const dateAzAZ: NDateLocale = {
  name: 'az-AZ',
  locale: az
}

export default dateAzAZ
